export default __webpack_public_path__ + "static/404-f3235698f7e253ae1af3bab154ddd2f5.png";